function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  transition: all ",
        ";\n  \n  /* Padding styles */\n  ",
        "\n  \n  /* Shadow styles */\n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n  \n  .dark & {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    \n    ",
        "\n  }\n\n  /* Responsive padding */\n  @media (max-width: 640px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid ",
        ";\n  \n  .dark & {\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  line-height: 1.75rem;\n  color: ",
        ";\n  \n  .dark & {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin: 0.5rem 0 0;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: ",
        ";\n  \n  .dark & {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  /* Content wrapper for consistent spacing */\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  padding-top: 1rem;\n  margin-top: 1rem;\n  border-top: 1px solid ",
        ";\n  \n  .dark & {\n    border-top-color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var StyledCard = styled.div(_templateObject(), function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.paper) || '#ffffff';
}, function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.border) || '#e5e7eb';
}, function(props) {
    var _props_theme_radius, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_radius = _props_theme.radius) === null || _props_theme_radius === void 0 ? void 0 : _props_theme_radius.lg) || '1rem';
}, function(props) {
    var _props_theme_transition, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_transition = _props_theme.transition) === null || _props_theme_transition === void 0 ? void 0 : _props_theme_transition.normal) || '300ms ease';
}, function(props) {
    switch(props.$padding){
        case 'none':
            return 'padding: 0;';
        case 'sm':
            return 'padding: 1rem;';
        case 'md':
            return 'padding: 1.5rem;';
        case 'lg':
            return 'padding: 2rem;';
        default:
            return 'padding: 1.5rem;';
    }
}, function(props) {
    switch(props.$shadow){
        case 'none':
            return '';
        case 'sm':
            return 'box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);';
        case 'md':
            return 'box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);';
        case 'lg':
            return 'box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);';
        default:
            return 'box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);';
    }
}, function(props) {
    return props.$clickable && "cursor: pointer;";
}, function(props) {
    var _props_theme;
    return props.$hover && "\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n      border-color: ".concat(((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.borderLight) || '#f3f4f6', ";\n    }\n  ");
}, function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.paperDark) || '#1f2937';
}, function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.borderLight) || '#374151';
}, function(props) {
    var _props_theme;
    return props.$hover && "\n      &:hover {\n        border-color: ".concat(((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.border) || '#4b5563', ";\n      }\n    ");
}, function(props) {
    switch(props.$padding){
        case 'none':
            return '';
        case 'sm':
            return 'padding: 0.75rem;';
        case 'md':
            return 'padding: 1rem;';
        case 'lg':
            return 'padding: 1.5rem;';
        default:
            return 'padding: 1rem;';
    }
});
var CardHeader = styled.div(_templateObject1(), function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.border) || '#e5e7eb';
}, function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.borderLight) || '#374151';
});
var CardTitle = styled.h3(_templateObject2(), function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.text) || '#111827';
}, function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.text) || '#f9fafb';
});
var CardDescription = styled.p(_templateObject3(), function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.textSecondary) || '#6b7280';
}, function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.textMuted) || '#9ca3af';
});
var CardContent = styled.div(_templateObject4());
var CardFooter = styled.div(_templateObject5(), function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.border) || '#e5e7eb';
}, function(props) {
    var _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.borderLight) || '#374151';
});
/**
 * Card component for containing and organizing content
 * 
 * @example
 * ```tsx
 * <Card>
 *   <Card.Header>
 *     <Card.Title>Card Title</Card.Title>
 *     <Card.Description>Optional description</Card.Description>
 *   </Card.Header>
 *   <Card.Content>
 *     Content goes here
 *   </Card.Content>
 *   <Card.Footer>
 *     Footer content
 *   </Card.Footer>
 * </Card>
 * ```
 */ export var Card = function(param) {
    var children = param.children, className = param.className, _param_padding = param.padding, padding = _param_padding === void 0 ? 'md' : _param_padding, _param_shadow = param.shadow, shadow = _param_shadow === void 0 ? 'sm' : _param_shadow, _param_hover = param.hover, hover = _param_hover === void 0 ? false : _param_hover, _param_clickable = param.clickable, clickable = _param_clickable === void 0 ? false : _param_clickable, onClick = param.onClick;
    return /*#__PURE__*/ React.createElement(StyledCard, {
        className: className,
        $padding: padding,
        $shadow: shadow,
        $hover: hover,
        $clickable: clickable,
        onClick: onClick
    }, children);
};
// Attach subcomponents
Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Description = CardDescription;
Card.Content = CardContent;
Card.Footer = CardFooter;
// Export individual components for named imports
export { CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
export default Card;
